import { Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Toaster } from "sonner";
import "@/App.css";
import HomePage from "@/pages/HomePage";
import ShopPage from "@/pages/ShopPage";
import AdminPage from "@/pages/AdminPage";
import PaymentSuccessPage from "@/pages/PaymentSuccessPage";
import PaymentCancelPage from "@/pages/PaymentCancelPage";
import NotFoundPage from "@/pages/NotFoundPage";
import PrivacyPolicyPage from "@/pages/PrivacyPolicyPage";
import TermsPage from "@/pages/TermsPage";
import ReturnPolicyPage from "@/pages/ReturnPolicyPage";
import ShippingPolicyPage from "@/pages/ShippingPolicyPage";
import WarrantyPage from "@/pages/WarrantyPage";
import AcademyPage from "@/pages/AcademyPage";
import ContactPage from "@/pages/ContactPage";
import useLenis from "@/hooks/useLenis";
import ConsentBanner from "@/components/ConsentBanner";
import { initAnalytics, trackPageView } from "@/lib/analytics";
import { CartProvider } from "@/context/CartContext";
import CartDrawer from "@/components/CartDrawer";

function App() {
  useLenis();
  const location = useLocation();

  useEffect(() => {
    initAnalytics();
  }, []);

  useEffect(() => {
    if (process.env.REACT_APP_GOOGLE_SITE_VERIFICATION) {
      let tag = document.querySelector('meta[name="google-site-verification"]');
      if (!tag) {
        tag = document.createElement("meta");
        tag.setAttribute("name", "google-site-verification");
        document.head.appendChild(tag);
      }
      tag.setAttribute("content", process.env.REACT_APP_GOOGLE_SITE_VERIFICATION);
    }
  }, []);

  useEffect(() => {
    const timer = window.setTimeout(() => {
      trackPageView(location.pathname + location.search);
    }, 0);
    return () => window.clearTimeout(timer);
  }, [location.pathname, location.search]);

  return (
    <CartProvider>
      <div className="App">
        <a
          href="#main-content"
          className="sr-only focus:not-sr-only focus:fixed focus:top-3 focus:left-3 focus:z-[999] focus:bg-[#FF6B00] focus:text-black focus:font-bold focus:uppercase focus:tracking-wider focus:text-sm focus:px-4 focus:py-2 focus:rounded-lg"
        >
          Skip to content
        </a>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/shop" element={<ShopPage />} />
          <Route path="/academy" element={<AcademyPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="/payment/success" element={<PaymentSuccessPage />} />
          <Route path="/payment/cancel" element={<PaymentCancelPage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
          <Route path="/terms-of-service" element={<TermsPage />} />
          <Route path="/return-policy" element={<ReturnPolicyPage />} />
          <Route path="/shipping-policy" element={<ShippingPolicyPage />} />
          <Route path="/warranty" element={<WarrantyPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
        <CartDrawer />
        <ConsentBanner />
        <Toaster
          theme="dark"
          position="bottom-right"
          toastOptions={{
            style: {
              background: "#111111",
              border: "1px solid rgba(255,255,255,0.08)",
              color: "#ffffff",
            },
          }}
        />
      </div>
    </CartProvider>
  );
}

export default App;
